module.exports = __webpack_public_path__ + "media/images/user/4-b8e967d458052eda2e6b4615962073d5.jpg";